import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const uploadApi = {
  // Upload medical record file
  uploadMedicalRecord: (file: File) => {
    const form = new FormData()
    form.append('file', file)
    return api.post<ApiResponse<{
      url: string;
      relativeUrl: string;
      originalName: string;
      size: number;
      filename: string;
    }>>('/uploads/medical-records', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  // List all uploaded files
  listFiles: () =>
    api.get<ApiResponse<Array<{
      filename: string;
      url: string;
      relativeUrl: string;
      size: number;
      uploadedAt: string;
    }>>>('/uploads'),

  // Get file info
  getFileInfo: (filename: string) =>
    api.get<ApiResponse<{
      filename: string;
      url: string;
      relativeUrl: string;
      size: number;
      uploadedAt: string;
    }>>(`/uploads/medical-records/${filename}`),

  // Delete uploaded file
  deleteFile: (filename: string) =>
    api.delete<ApiResponse<any>>(`/uploads/medical-records/${filename}`)
}

